export const getYear = state => state.reportCostTypeCosts.getIn(['list', 'year'])

export const getData = state => state.reportCostTypeCosts.getIn(['list', 'data'])
export const getFetching = state => state.reportCostTypeCosts.getIn(['list', 'fetching'])
export const getError = state => state.reportCostTypeCosts.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCostTypeCosts.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCostTypeCosts.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCostTypeCosts.getIn(['details', 'error'])
